import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { Image } from "../../../foundations/Image/Image";
import { buildImageSizes } from "../../../foundations/Image/utils/buildImageSizes";
import { buildImageSrcSet } from "../../../foundations/Image/utils/buildImageSrcSet";
import { CATEGORY_CARD_MEDIUM_IMAGE_SIZE, CATEGORY_CARD_SMALL_IMAGE_SIZE } from "../constants";
import * as styles from "./CategoryCard.styles";
export var CategoryCard = function CategoryCard(_ref) {
  var _images$;
  var backgroundColor = _ref.backgroundColor,
    categoryHref = _ref.categoryHref,
    categoryName = _ref.categoryName,
    imageHeight = _ref.imageHeight,
    imageWidth = _ref.imageWidth,
    images = _ref.images,
    lazyImages = _ref.lazyImages,
    onLinkClick = _ref.onLinkClick;
  var handleClick = function handleClick(e) {
    onLinkClick === null || onLinkClick === void 0 || onLinkClick(e);
  };
  var imagesWithUnit = images.map(function (_ref2) {
    var src = _ref2.src,
      width = _ref2.width;
    return {
      src,
      width,
      unit: 'w'
    };
  });
  return /*#__PURE__*/React.createElement(_StyledA, {
    href: categoryHref,
    onClick: handleClick,
    $_css: styles.link
  }, /*#__PURE__*/React.createElement(_StyledImage, {
    height: imageHeight,
    loading: lazyImages ? 'lazy' : 'eager',
    sizes: buildImageSizes({
      XXS: "".concat(CATEGORY_CARD_SMALL_IMAGE_SIZE, "px"),
      M: "".concat(CATEGORY_CARD_MEDIUM_IMAGE_SIZE, "px")
    }),
    src: (_images$ = images[0]) === null || _images$ === void 0 ? void 0 : _images$.src,
    srcSet: buildImageSrcSet(imagesWithUnit),
    width: imageWidth,
    $_css2: styles.image
  }), /*#__PURE__*/React.createElement(_StyledP, {
    style: {
      '--backgroundColor': backgroundColor
    },
    $_css3: styles.categoryTitle
  }, categoryName));
};
var _StyledA = _styled("a")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledImage = _styled2(Image)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledP = /*#__PURE__*/_styled3("p").withConfig({
  displayName: "CategoryCard___StyledP",
  componentId: "sc-12tteuf-0"
})(["", ""], function (p) {
  return p.$_css3;
});